import { SharesItemFragment, SocialAccount } from 'api';
import { find } from 'lodash';
import { getSocialAccountName } from 'helpers';

export const getSocialAccount = (item: SharesItemFragment, connections: SocialAccount[]) => {
  const { network_id } = item;
  const account = find(connections, ['id', network_id]);

  return getSocialAccountName(account);
};
